import { ResourceType } from '@treasury/domain/channel/services/user-activity';
// eslint-disable-next-line import/extensions
import { constantsModule } from './constants';

constantsModule.constant('resourceType', ResourceType); // backfills the Angular constant until the controllers that use it are migrated.
